import React from "react";
import { Link } from "react-router-dom";
import PolicyPage from "./PolicyPage";
import "../css/terms.scss";

const sections = [
  {
    id: "agreement",
    title: "Agreement to these terms",
    content: (
      <>
        <p>
          These terms govern your access to dzcp896.com and purchases from DZCP
          HiFi, operated by Mystron Technology Limited. By browsing the store,
          creating an account or placing an order, you agree to these terms and
          the policies linked from them.
        </p>
        <p>
          You must be legally able to enter into a contract in your location.
          If you use the store for an organization, you confirm that you have
          authority to accept these terms for it.
        </p>
      </>
    ),
  },
  {
    id: "store-use",
    title: "Using our online store",
    content: (
      <>
        <p>
          You are responsible for the accuracy of information submitted through
          your account and for keeping account credentials confidential. Please
          notify us promptly if you believe your account has been accessed
          without permission.
        </p>
        <p>You may not use the website to:</p>
        <ul>
          <li>Break applicable law or infringe another person’s rights</li>
          <li>Submit false, fraudulent, harmful or misleading information</li>
          <li>Interfere with security, availability or normal store operation</li>
          <li>Copy, scrape or exploit store content without permission</li>
          <li>Transmit malware, automated spam or destructive code</li>
        </ul>
      </>
    ),
  },
  {
    id: "products-pricing",
    title: "Products, descriptions and pricing",
    content: (
      <>
        <p>
          We aim to display product descriptions, specifications, availability,
          colors and prices accurately. Screen settings and photography can
          affect how a product appears, and packaging or minor details may
          change without affecting its core function.
        </p>
        <p>
          Prices are shown in the currency displayed at checkout. Delivery,
          taxes, duties or other charges are shown separately when applicable.
          We may correct obvious errors or update prices before accepting an
          order.
        </p>
      </>
    ),
  },
  {
    id: "orders-payment",
    title: "Orders and payment",
    content: (
      <>
        <p>
          An order is an offer to purchase. Receiving an order confirmation does
          not mean the order has been accepted; acceptance occurs when the order
          is dispatched or we otherwise confirm acceptance. We may reject or
          cancel an order for payment, inventory, pricing, security or delivery
          reasons and will refund any amount charged for a cancelled item.
        </p>
        <p>
          You authorize our payment provider to charge the selected payment
          method for the order total. Information supplied for payment and
          delivery must be complete and accurate.
        </p>
      </>
    ),
  },
  {
    id: "shipping-returns",
    title: "Shipping, cancellation and returns",
    content: (
      <>
        <p>
          Delivery dates are estimates rather than guarantees. Risk of loss and
          ownership pass as required by the law that applies to your purchase.
          Full processing, tracking and customs information is available in our
          <Link to="/shipping"> Delivery Policy</Link>.
        </p>
        <p>
          You may request cancellation before an order is dispatched. Eligible
          products may be returned within 14 days of receipt in accordance with
          our <Link to="/returns">Returns & Refunds Policy</Link> and any
          mandatory consumer rights in your location.
        </p>
      </>
    ),
  },
  {
    id: "intellectual-property",
    title: "Intellectual property",
    content: (
      <p>
        The website design, text, graphics, logos, photographs, product
        presentation and software are owned by us or used under license. You may
        view and use the store for personal shopping, but you may not reproduce,
        distribute, modify or commercially exploit this material without prior
        written permission.
      </p>
    ),
  },
  {
    id: "third-party-services",
    title: "Third-party tools and links",
    content: (
      <p>
        Some features are provided by payment, delivery, analytics or other
        third-party services. Their services may be subject to separate terms
        and privacy notices. We are not responsible for content or services on
        external websites that we do not control.
      </p>
    ),
  },
  {
    id: "warranties-liability",
    title: "Warranties and liability",
    content: (
      <>
        <p>
          We provide the website with reasonable care but cannot promise that it
          will always be uninterrupted or error-free. Product warranties are
          limited to those stated with the product and rights that cannot be
          excluded by law.
        </p>
        <p>
          To the fullest extent permitted by law, we are not liable for indirect
          or consequential losses that were not reasonably foreseeable. Nothing
          in these terms excludes liability or consumer rights that the law does
          not allow us to exclude.
        </p>
      </>
    ),
  },
  {
    id: "changes-law-contact",
    title: "Changes, applicable law and contact",
    content: (
      <>
        <p>
          We may update these terms when our store, services or legal obligations
          change. Updated terms apply from the date posted and do not reduce
          rights already attached to a completed purchase.
        </p>
        <p>
          These terms are governed by the laws applicable to Mystron Technology
          Limited and your transaction, without limiting any mandatory rights in
          your place of residence. Questions can be sent to
          <a href="mailto:support@dzcp896.com"> support@dzcp896.com</a> or
          through our <Link to="/contact">contact page</Link>.
        </p>
      </>
    ),
  },
];

function Terms() {
  return (
    <PolicyPage
      className="terms"
      title="Terms & Conditions"
      summary="These terms set out the rules for using our store and explain what you can expect when you place an order with DZCP HiFi."
      sections={sections}
    />
  );
}

export default Terms;
